import { Action } from '@ngrx/store';

export function isSameAction(target: Action, matching: Action) {
  return target.type === matching.type;
}
